import React from "react";
import { TurnrCard } from "~/components/card/TurnrCard.jsx";
import SkeletonLoaderCard from "~/components/loading/skeletons/SkeletonLoaderCard.jsx";
import { serviceIsLoadingOrNotFetched } from "rylak-common";
import { COLORS } from "rylak-common/src/constants";
import HoverText from "~/components/tooltip/HoverText.jsx";
import { TurnrFontAwesomeIconButtonRound } from "~/components/buttons/icon-buttons/TurnrFontAwesomeIconButton";
import { faChevronRight, faPercent } from "@fortawesome/pro-regular-svg-icons";
import { faBarsSort } from "@fortawesome/pro-solid-svg-icons";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import * as styles from "./GraphCardWithTitle.module.scss";
import classNames from "classnames";
import LineDivider from "rylak-common/src/components/divider/LineDivider";

const padding = "16px 16px 16px 16px";

export default function GraphCardWithTitle(props) {
    const {
        title,
        description,
        serviceData,
        height,
        divider = false,
        loadingMinWidth,
        loading = serviceIsLoadingOrNotFetched(serviceData),
        onPercentClick,
        percentIsOn,
        onChartSortClick,
        chartSortValue,
        onChartExpanded,
        chartExpanded,
        children,
    } = props;

    const showTitle = title || description || onChartSortClick || onPercentClick || onChartExpanded;

    return (
        <TurnrCard
            style={{
                overflow: "initial",
                position: "relative",
                height: height || (chartExpanded ? "fit-content" : "360px"),
                minHeight: !height && "360px",
            }}
        >
            <div
                style={{
                    height: "100%",
                    visibility: loading && "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {showTitle && (
                    <div
                        style={{
                            display: "flex",
                            fontSize: "12px",
                            justifyContent: "space-between",
                            padding: padding,
                        }}
                    >
                        <div
                            style={{
                                color: COLORS.SLIGHTLY_WEAK_TEXT,
                            }}
                        >
                            {description ? <HoverText text={title} hoverContent={<div style={{ color: COLORS.WEAK_TEXT }}>{description}</div>} maxTooltipWidth={"300px"} /> : title}
                        </div>
                        <div style={{ display: "flex", gridGap: "15px" }}>
                            {onChartSortClick && (
                                <div
                                    style={{
                                        marginTop: "-8px",
                                        marginRight: "-8px",
                                    }}
                                >
                                    <TurnrTooltip
                                        content={
                                            <div>
                                                Sorting by{" "}
                                                <span
                                                    style={{
                                                        color: chartSortValue,
                                                    }}
                                                >
                                                    {chartSortValue === COLORS.RETURN ? "Returns" : chartSortValue === COLORS.EXCHANGE ? "Exchanges" : "Complaints"}
                                                </span>
                                            </div>
                                        }
                                    >
                                        <TurnrFontAwesomeIconButtonRound icon={faBarsSort} onClick={onChartSortClick} on={false} color={chartSortValue} />
                                    </TurnrTooltip>
                                    {/*<TurnrCheckbox size={"small"}></TurnrCheckbox>*/}
                                </div>
                            )}
                            {onPercentClick && (
                                <div
                                    style={{
                                        marginTop: "-8px",
                                        marginRight: "-8px",
                                    }}
                                >
                                    <TurnrTooltip content={<div>Sorting by {percentIsOn ? "percentage %" : "amount"}</div>}>
                                        <TurnrFontAwesomeIconButtonRound icon={faPercent} onClick={onPercentClick} on={percentIsOn} color={COLORS.INFO} />
                                    </TurnrTooltip>
                                    {/*<TurnrCheckbox size={"small"}></TurnrCheckbox>*/}
                                </div>
                            )}
                            {onChartExpanded && (
                                <div
                                    style={{
                                        marginTop: "-8px",
                                        marginRight: "-8px",
                                    }}
                                >
                                    <TurnrTooltip content={<div>Show more items</div>}>
                                        <TurnrFontAwesomeIconButtonRound
                                            icon={faChevronRight}
                                            className={classNames(styles["expand-arrow"], chartExpanded && styles["open"])}
                                            onClick={onChartExpanded}
                                            on={chartExpanded}
                                            color={COLORS.INFO}
                                        />
                                    </TurnrTooltip>
                                    {/*<TurnrCheckbox size={"small"}></TurnrCheckbox>*/}
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {divider && showTitle && <LineDivider />}
                <div
                    style={{
                        padding: padding,
                        height: "100%",
                        overflow: "hidden",
                    }}
                >
                    {!loading && children}
                </div>
            </div>
            {loading && (
                <div style={{ minWidth: loadingMinWidth }}>
                    <SkeletonLoaderCard />
                </div>
            )}
        </TurnrCard>
    );
}
